import { render } from "./Character.vue?vue&type=template&id=0344fe33&scoped=true"
import script from "./Character.vue?vue&type=script&lang=js"
export * from "./Character.vue?vue&type=script&lang=js"

import "./Character.vue?vue&type=style&index=0&id=0344fe33&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/gilcode.com/kwordz.gilcode.com/packages/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0344fe33"]])

export default __exports__